<template>
	<div class="button" :class="[color, {enabled: enabled}]" @click="onClick">
		<div class="inner">
			<slot/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Button',
	props: {
		color: {
			type: String,
			default: 'light'
		},
		enabled: {
			type: Boolean,
			default: true,
		}
	},
	methods: {
		onClick(e) {
			let name = this.$slots.default[0].text
			let page = this.$route.name
			ga('send', 'event', 'button', name + ' at ' + page)
			this.$emit('click', e)
		}
	},
}
</script>

<style scoped lang="less">
@import "../styles.less";

.button {
	width: fit-content;
	cursor: default;
	transition: all 300ms ease;
	margin: 0 auto;
	opacity: 0.3;

	.inner {
		height: 40px;
		margin: 5px;
		padding: 0 30px;
		line-height: 40px;
		transition: all 300ms ease;
		text-decoration: none;
	}

	&.enabled {
		cursor: pointer;
		opacity: 1;
	}
}

.button.dark {
	border: 3px solid #000;

	.inner {
		border: 1px solid #000;
		color: #000;
	}

	&.enabled:hover .inner {
		background: #000;
		color: @color-main;
	}
}

.button.light {
	border: 3px solid #fff;

	.inner {
		border: 1px solid #fff;
		color: #fff;
	}

	&.enabled:hover .inner {
		background: #fff;
		color: #000;
	}
}
</style>
